/* eslint-disable */
export default {
  "components": [
    {
      "autofocus": false,
      "input": true,
      "tableView": true,
      "inputType": "email",
      "label": "Email registrado",
      "key": "email",
      "placeholder": "email@example.com",
      "prefix": "",
      "suffix": "",
      "defaultValue": "",
      "protected": false,
      "unique": false,
      "persistent": true,
      "hidden": false,
      "clearOnHide": true,
      "kickbox": {
        "enabled": false
      },
      "type": "email",
      "labelPosition": "top",
      "inputFormat": "plain",
      "tags": [],
      "conditional": {
        "show": "",
        "when": null,
        "eq": ""
      },
      "properties": {},
      "validate": {
        "required": true
      }
    },
    {
      "autofocus": false,
      "input": true,
      "label": "Enviar correo de recuperación",
      "tableView": false,
      "key": "submit",
      "size": "md",
      "leftIcon": "",
      "rightIcon": "",
      "block": false,
      "action": "submit",
      "disableOnInvalid": false,
      "theme": "success",
      "type": "button",
      "tags": [],
      "conditional": {
        "show": "",
        "when": null,
        "eq": ""
      },
      "properties": {
        
      }
    }
  ],
  "display": "form"
}